<template>
  <div v-if="disabled" class="-transcribe -action -disabled">
    <span class="wticon wticon-Transcript" />
  </div>
  <div
    v-else
    class="-transcribe -action"
    @click="$emit('transcribe')"
    v-tooltip="tooltipOptions"
  >
    <span class="wticon wticon-Transcript" />
  </div>
</template>

<script>
export default {
  name: 'AssetEdit',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipOptions() {
      return {
        title: 'Transcript',
        placement: 'top auto',
        delay: { show: 250, hide: 0 },
        wrapperClass: 'dark',
        container: '.tooltip-container',
      };
    },
  },
};
</script>
